<template>
    <applyModal :modalTitle="'信息变更申请'" :isDetailStatus="false" ref="modalDetailRef">
        <div class="mt20 mb62">
            <div class="modal_content">
                <div class="file_text">
                    智能网联汽车道路测试或示范应用变更信息表
                </div>
                <div class="into">下载模板，根据模板提示完善内容</div>
                <div class="update_btn">
                    <div><i class="iconfont icon-dianjixiazaiicon update_icon mr5"></i>
                        <template v-if="props.info">
                            <a :href="props.info.templateFileUrl">点击下载</a>
                        </template>
                    </div>
                </div>
            </div>
            <div class="mt16">
                <upload :pathName="'car'" ref="uploadRef" accept=".xls,.docx,.doc" @uploadFinished="uploadFinished"></upload>
            </div>
            <div class="mt16 list">
                <div class="tit">申请记录</div>
                
                <div class="modal_table">
                    <div class="info">如果变更涉及到车辆基本信息的更改，请审核通过后对车辆信息进行更改。</div>
                    <a-table  v-if="props.info" :columns="columns" :row-key="(record) => record.applyTime" :data-source="props.info.records"
                        size="middle" :pagination="false" :scroll="{ y:120}">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'applyTime'">
                                {{ moment(record.applyTime).format("YYYY-MM-DD HH:mm:ss") }}
                            </template>
                            <template v-if="column.key === 'checkOpinion'">
                              {{record.checkResult===1?'通过':record.checkResult===0?'不通过':''}} <span v-if="record.checkResult">,</span>  {{record.checkOpinion }}
                            </template>
                            
                            <template v-else-if="column.key === 'action'">
                                <span>
                                    <a :href="record.fileUrl" class="alink">下载变更信息表</a>

                                </span>
                            </template>
                        </template>
                    </a-table>
                </div>

            </div>

            <div class="mt16 botmBtn">
                <a-button type="primary" ghost class="mr10"  @click="cancel">取消</a-button>
                <a-button type="primary" class="ml10" @click="confirm">确定</a-button>
            </div>
        </div>
    </applyModal>
</template>

<script setup>
import { ref, onMounted, reactive, watch, nextTick, defineExpose,defineProps,defineEmits } from "vue";
import applyModal from '@/components/modal/index.vue'
import upload from '@/components/uploadProgress/index.vue'
import moment from "moment";

const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
})

const emits = defineEmits(["save"]);


const uploadRef=ref();
const modalDetailRef = ref()
const show = (record) => {
    modalDetailRef.value.showModal()
}



const columns=[
    {
        title: "申请时间",
        dataIndex: "applyTime",
        key: "applyTime",
    },
    {
        title: "联合小组审核意见",
        // dataIndex: "checkOpinion",
        key: "checkOpinion",
    },
    {
        title: "操作",
        dataIndex: "action",
        key: "action",
    },
]



//下载信息变更表
function downloadFile(row){
    console.log(row)
}

let fileUrl=ref();
const uploadFinished = (res) => {
    console.log('上传成功',res);
    fileUrl.value=res
}

// 保存
const confirm = () => {
    emits('save',fileUrl.value)
    uploadRef.value.reset();
   
}
// 取消
const cancel = () => {
    modalDetailRef.value.hideModal()
    uploadRef.value.reset();
}


defineExpose({
    show,
    cancel
})

</script>

<style lang="less" scoped>
.mb62 {
    margin-bottom: 62px;
}

.modal_content {
    // width: 516px;
    height: 154px;
    background: rgba(246, 248, 250, 1);
    display: flex;
    flex-direction: column;
    align-items: center;

    .file_text {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #1D2129;
        padding-top: 24px;
    }

    .into {
        font-size: 14px;
        color: #636D7B;
        margin: 16px 0;
    }

    .update_btn {
        cursor: pointer;
        padding: 3px 0;
        width: 100px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #636D7B;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #636D7B;
        text-align: center;
    }
}
/deep/.list{
    .tit{
        font-size: 16px;
        color: #1D2129;
        margin: 28px 0 22px 0;
        font-weight: 400;
    }
    .info{
        color: #636D7B;
        font-size: 14px;
        margin-bottom: 17px;
    }
    .modal_table{
        background: #F6F8FA;
        border-radius: 4px 4px 4px 4px;
        padding: 10px 27px;
        font-size: 12px;
        th{
            background: #fff!important;
            text-align: center;
            font-size: 12px;
        }
        td{
            text-align: center;
            font-size: 12px;
        }
        .alink{
            color: #186FF2;
            font-size: 12px;
        }
    }
}
.botmBtn{
    display: flex;
    justify-content: center;
    .mr10{
        margin-right: 5%;
        margin-left: 5%;
    }
    .ml10{
        margin-left: 5%;
    }
}
</style>